import { useRef } from 'react';

/**
 * This replaces useMemo(), the differences are:
 * 1. Never clears the cache
 * 2. Does not re-calculate
 *
 * @param init_value A static value or a function. The function is called once for initialization only
 * @returns
 */
export function useStaticMemo<T>(init_value: () => T): T {
	const ref = useRef<T>();
	if (ref.current === undefined) {
		ref.current = init_value();

		//in order to prevent repeated call of the function, convert undefined to null
		if (ref.current === undefined) {
			ref.current = null as any;
		}
	}
	return ref.current!;
}
